import { useContext } from 'react';
import { Col, Container, Modal, Row } from "react-bootstrap";
import { PrimaryGreenButton, SecondaryGreenButton } from '../../../Buttons/styles';
import { AddFileNavigationPositionEnum } from '../../../../domain/enum/AddFileNavigationPosition';
import { AddImageModalContext } from '../context/AddImageModalContext';

export const AddImageModalFooter = () => {
    const {
        navigationPosition, handleAddFileButton, onSubmit, isUploading, isVideoValid,
        imageObject: videoObject
    } = useContext(AddImageModalContext);

    return (
        <Modal.Footer>
            {(navigationPosition !== AddFileNavigationPositionEnum.index && !isUploading) && (
                <Container>
                    <Row className="mb-2">
                        {navigationPosition === AddFileNavigationPositionEnum.sendFile&&videoObject.ImageUrl!==""?
                            (
                                <Col md="auto">
                                    <SecondaryGreenButton onClick={handleAddFileButton} className="py-2 px-3">
                                        <Row>
                                            <Col md="auto" className="my-auto pr-0">
                                                <i className='bi bi-arrow-repeat' />
                                            </Col>
                                            <Col className="my-auto">
                                                <p>
                                                    Alterar Arquivo
                                                </p>
                                            </Col>
                                        </Row>
                                    </SecondaryGreenButton>
                                </Col>
                            )
                            :
                            (
                                <></>
                            )}

                        <Col md="auto" className="ml-auto">
                            {/*disabled se NÃO for valido*/}
                            <PrimaryGreenButton className="py-2 px-3" disabled={!isVideoValid()} onClick={() => onSubmit()}>
                                <Row>
                                    <Col className="my-auto">
                                        <p>
                                            Enviar Imagem
                                        </p>
                                    </Col>
                                    <Col md="auto" className="my-auto pl-0">
                                        <i className="bi bi-check" />
                                    </Col>
                                </Row>
                            </PrimaryGreenButton>
                        </Col>
                    </Row>
                </Container>
            )}
        </Modal.Footer>
    );
};
